import { RootState } from "../app/store";

export const selectIsNavbar = (state: RootState) => state.layout.isNavbar
export const selectIsWidgetsOpen = (state: RootState) => state.layout.isWidgetsOpen